(function () {
var $befaf388e0876dac$export$eb1fa9926d9eaa10 = function domContentLoaded(callback) {
    document.addEventListener("DOMContentLoaded", callback);
};
var $befaf388e0876dac$export$4853a064df83856e = function isMobileOrTablet() {
    var check = false;
    (function(a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};
var $befaf388e0876dac$export$cc883c5fe8d3bbfc = function(s) {
    return s.toString().replace(/\d/g, function(d) {
        return "۰۱۲۳۴۵۶۷۸۹"[d];
    });
};
var $befaf388e0876dac$export$dbf5eda5be325c40 = function(s) {
    return s.toString().replace(/\d/g, function(d) {
        return "٠١٢٣٤٥٦٧٨٩"[d];
    });
};
var $befaf388e0876dac$export$762828a7f4803753 = function(s) {
    return s.toString().replace(/[۰-۹]/g, function(d) {
        return "۰۱۲۳۴۵۶۷۸۹".indexOf(d);
    });
};
var $befaf388e0876dac$export$f26643d7bfe2169f = function(s) {
    return s.replace(/[٠-٩]/g, function(d) {
        return "٠١٢٣٤٥٦٧٨٩".indexOf(d);
    });
};
var $befaf388e0876dac$export$41a973d97f222eee = function(s) {
    return s.toString().replace(/[۰-۹]/g, function(d) {
        return "٠١٢٣٤٥٦٧٨٩"["۰۱۲۳۴۵۶۷۸۹".indexOf(d)];
    });
};
var $befaf388e0876dac$export$d77f0231a535c7bc = function(s) {
    return s.toString().replace(/[٠-٩]/g, function(d) {
        return "۰۱۲۳۴۵۶۷۸۹"["٠١٢٣٤٥٦٧٨٩".indexOf(d)];
    });
};
function $befaf388e0876dac$export$732afeaa2c54a6d1(callback) {
    var idleTimeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e4;
    var resetTimer = function resetTimer() {
        clearTimeout(t);
        callback === null || callback === void 0 ? void 0 : callback.active();
        t = setTimeout(callback === null || callback === void 0 ? void 0 : callback.inactive, idleTimeout); // time is in milliseconds
    };
    var t;
    window.onload = resetTimer;
    window.onmousemove = resetTimer;
    window.onmousedown = resetTimer; // catches touchscreen presses as well
    window.ontouchstart = resetTimer; // catches touchscreen swipes as well
    window.ontouchmove = resetTimer; // required by some devices
    window.onclick = resetTimer; // catches touchpad clicks as well
    window.onkeydown = resetTimer;
    window.addEventListener("scroll", resetTimer, true); // improved; see comments
}
var $befaf388e0876dac$export$688d13a530c5dcbc = function numberFormat(value, decimals) {
    if (!value && value !== 0) return 0;
    if (isNaN(value)) return "";
    return value.toString().replace(/,/g, "").toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
};


var $ed03e93b015feea6$var$LoanApp = function LoanApp(config, $) {
    var app = this;
    app.elms = {};
    app.elms.$wrap = $(config.wrapId);
    app.elms.range = document.querySelector(".loan__slider");
    app.elms.$earn = app.elms.$wrap.find(".loan__earn");
    app.elms.$order = app.elms.$wrap.find(".loan__order");
    var events = new function() {
        this.bind = function() {
            app.elms.range.addEventListener("input", rangeSliderChanged);
        };
    };
    var rangeSliderChanged = function rangeSliderChanged() {
        switch(this.value){
            case "1":
            case "0":
                app.elms.$earn.html((0, $befaf388e0876dac$export$cc883c5fe8d3bbfc)(10));
                app.elms.$order.html((0, $befaf388e0876dac$export$cc883c5fe8d3bbfc)(1));
                break;
            case "5":
                app.elms.$earn.html((0, $befaf388e0876dac$export$cc883c5fe8d3bbfc)(20));
                app.elms.$order.html((0, $befaf388e0876dac$export$cc883c5fe8d3bbfc)(5));
                break;
            case "10":
                app.elms.$earn.html((0, $befaf388e0876dac$export$cc883c5fe8d3bbfc)(30));
                app.elms.$order.html((0, $befaf388e0876dac$export$cc883c5fe8d3bbfc)(10));
                break;
            case "15":
                app.elms.$earn.html((0, $befaf388e0876dac$export$cc883c5fe8d3bbfc)(40));
                app.elms.$order.html((0, $befaf388e0876dac$export$cc883c5fe8d3bbfc)(15));
                break;
            case "20":
                app.elms.$earn.html((0, $befaf388e0876dac$export$cc883c5fe8d3bbfc)(50));
                app.elms.$order.html((0, $befaf388e0876dac$export$cc883c5fe8d3bbfc)(20));
                break;
        }
    };
    app.init = function() {
        events.bind();
        return this;
    };
};
new $ed03e93b015feea6$var$LoanApp({
    wrapId: ".loan"
}, jQuery).init();

})();
//# sourceMappingURL=index.js.map
